import IntentManage from './IntentManage';

export default {
  displayNameKey: 'intent_engine',
  icon: 'menu_intent',
  pages: {
    IntentManage,
  },
};



// WEBPACK FOOTER //
// ./src/modules/IntentEngine/index.js